<template>
  <div class="p-4 bg-indigo-300 rounded flex items-center justify-between max-w-3xl">
    <div class="flex items-center">
      <icon name="preview" class="flex-shrink-0 w-9 h-9 fill-yellow-800 mr-2 va-m" />
      <div class="text-sm font-medium text-yellow-800 ml-5">
        <template v-for="node in nodes">
            <img v-if="is_emote(node)" :src="image_src(node)" class="align-middle inline-block" :alt="node" :key="node"/>
            <a v-else-if="is_link(node)" :href="node" class="text-indigo-500 hover:text-indigo-600" :key="node"> {{node}}</a>
            <template v-else> 
              <template v-if="is_placeholder(node)">
                <template v-if="commands[node.substring(1)]['is_enabled'] == true">
                  <span :key="node" class="highlight">
                  <template v-for="node_p, p in placeholder_nodes(commands[node.substring(1)]['command_reply'])">
                    <img v-if="is_emote(node_p)" :src="image_src(node_p)" class="align-middle inline-block" :alt="node_p" :key="p"/>
                    <a v-else-if="is_link(node_p)" :href="node" class="text-indigo-500 hover:text-indigo-600" :key="p"> {{node_p}} </a>
                    <template v-else>
                      {{ node_p }}
                    </template>
                  </template>
                  </span>
                </template>
                <template v-else>
                  <span :key="node" class="highlight">
                  {{ node }} [COMMAND CURRENTLY NOT ENABLED]
                  </span>
                </template>
              </template>
              <template v-else>
              {{ node }}
              </template>
            </template>
        </template>
      </div>
    </div>
  </div>
</template>
<style scoped>
.highlight {
  background: linear-gradient(
      100deg,
      rgba(255, 221, 64, 0) 0.9%,
      rgba(255, 221, 64, 1) 2.4%,
      rgba(255, 221, 64, 0.5) 5.8%,
      rgba(255, 221, 64, 0.1) 93%,
      rgba(255, 221, 64, 0.7) 96%,
      rgba(255, 221, 64, 0) 98%
    ),
    linear-gradient(
      180deg,
      rgba(255, 221, 64, 0) 0%,
      rgba(255, 221, 64, 0.3) 7.9%,
      rgba(255, 221, 64, 0) 15%
    );
  border-radius: 0.125em;
  box-decoration-break: clone;
  font-style: normal;
  padding: 0.125em 0.25em;
}
</style>
<script>
import Icon from '@/Shared/Icon'
import useTwitch from '@/Shared/useTwitch'
import useHelper from '@/Shared/useHelper'

export default {
  components: {
    Icon,

  },
  props: ['preview_message'],
  data() {
    return {
      twitchApi: null,
      helperApi: null,
    }
  },
  created() {
    // initialize composables and fetch data (if not already cached)
    this.twitchApi = useTwitch()
    if (!this.twitchApi.state.emotes) {
      this.twitchApi.fetchEmotes()
    }

    this.helperApi = useHelper()
    if (!this.helperApi.state.commands) {
      this.helperApi.fetchCommands()
    }
  },
  computed: {
    nodes() {
      try {
          return this.preview_message.split(' ')
        }
      catch (e) {
        return this.preview_message
      }
    },
    // prefer the client-fetched emotes, fall back to server-shared prop if not present
    emotes() {
        return (this.twitchApi && this.twitchApi.state.emotes) || {}
    },
    commands() {
        return (this.helperApi && this.helperApi.state.commands) || {}
    }
  },
    methods: {
    is_emote(node) {
        return node in this.emotes
    },
    image_src(node) {
        // simple lookup; returns undefined if not found
        return this.emotes ? this.emotes[node] : undefined
    },
    is_link(node) {
      return /http[\w]?:\/\//.test(node)
    },
    placeholder_nodes(data) {
      try {
          return data.split(' ')
        }
      catch (e) {
        return this.data
      }
    },
    is_placeholder(node) {
      var placeholder_detected = /\$(\w+)/.test(node);
      if (placeholder_detected) {
        var placeholder = node.substring(1);
        if (placeholder in this.commands) {
          return true;
        }
      } else  {
        return false;
      }
    }
  },
}
</script>
